//added by Samikchha Kumar on 25-Mar-2023
import { Component, OnInit, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { Location } from '@angular/common';
import { ExcelUploadService } from 'src/app/Global-Services/excel-upload.service';
import { FteFinanceUplodPopUpComponent } from 'src/app/Module/Pages/fte-finance-uplod-pop-up/fte-finance-uplod-pop-up.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-fterecords',
  templateUrl: './fterecords.component.html',
  styleUrls: ['./fterecords.component.css'],
  providers: [CommonService],
  standalone: false,
})
export class FTERecordsComponent implements OnInit {
  ID: '';
  filteredClientSingle: any[] = []
  filteredEmployeeSingle: any[] = []
  filteredEngagementSingle: any[] = []
  filteredManagerSingle: any[] = []
  EmployeeName: string[];
  EmployeeCode: string[];
  EngagementCode: string[]; //Added by samikchha
  ClientName: string[];   //Added by samikchha
  ManagerName: string[];
  reverse = false;
  IsSLHR = false;
  sortkey: any;
  ViewFTERecordsList: any[];
  ParamID: any;
  CurrUserGPN = '';
  PageNumber = 1;
  EmployeeList = {
    Employee: null
  };
  ManagerList = {
    Manager: null,
  };
  EmployeeCodeList = {
    EmployeeCode: null
  }
  EngagementList = {
    EngCode: null
  }
  ClientList = {
    Client: null
  }
  boolReturn: any;
  LabelName: any;
  IsExport: boolean;
  IsAdmin: boolean;
  IsBUOUSpoc = false;
  ErrorMessage = [];
  FTERecordsList = {
    TopRecord: 0,
    TotalRecord: 0,
    RecordFrom: 0,
    RecordTo: 0,
    TotalPageCount: 0,
    currentPage: 1,
    ID: '',
    EmpGPN: '',
    EmpLPN: '',
    EmpName: '',
    ServiceLineID: '',
    ServiceLineText: '',
    EmpTitle: '',
    EmpLocationID: '',
    EmpLocationText: '',
    EmpDOJ: '',
    EmpManagerGPN: '',
    EmpManagerName: '',
    EmpFirm: '',
    EmpPartnerName: '',
    EmpEmail: '',
    IDList: '',
    UpdatedEngagementCode: '',
    EngClientName: ''
  };
  LocationList: any[];
  ServiceLineList: any[];
  TitleList: any[];
  IsCounsellor = false;
  IsManager = false;
  IsPartner = false;
  Roles = [];
  href: any;
  constructor(
    public route: ActivatedRoute
    , public ExcelUpload: ExcelUploadService
    , public gService: CommonService
    , public dialog: MatDialog
    , public datepipe: DatePipe
    , private gVariable: GlobalVariable
    , private router: Router
  ) { }

  ErrorMassage: any[];

  ngOnInit() {
    this.gVariable.User = this.gService.getUserDetails('zero');
    this.ID = this.route.snapshot.queryParams['ID'];
    this.CurrUserGPN = this.gVariable.User.UserGPN;
    this.Roles = this.gVariable.User._ApplicationRole.split(',');

    this.IsAdmin = this.Roles.indexOf('Admin1') > -1 ? true : false;
    this.IsBUOUSpoc = this.Roles.indexOf('BUOUSpoc') > -1 ? true : false;
    this.IsCounsellor = this.Roles.indexOf('IsCounsellor') > -1 ? true : false;
    this.IsManager = this.Roles.indexOf('IsManager') > -1 ? true : false;
    this.IsPartner = this.Roles.indexOf('IsPartner') > -1 ? true : false;
    this.IsSLHR = this.Roles.indexOf('IsSLHR') > -1 ? true : false;

    this.ParamID = this.route.snapshot.paramMap.get('ParamID');
    this.GetSearchResult();
    this.filteredEmployeeSingle = [];
    this.filteredManagerSingle = [];
    this.ShowLabel();

  }

  ShowLabel() {
    if (this.ParamID == 1) {
      this.LabelName = "View All Records";
    }
    if (this.ParamID == 2) {
      this.LabelName = "Pending for Engagement Code update";
    }
    if (this.ParamID == 3) {
      this.LabelName = "Pending for Engagement Code review";
    }
    if (this.ParamID == 4) {
      this.LabelName = "View Transitioned Records";
    }
  }

  GetEmpCodeSearch(event: any) {

    this.EmployeeCode = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEmpCodeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {

        this.EmployeeCode = [];
        this.EmployeeCode = data;
        this.filteredEmployeeSingle = this.filterFilterCode(query, this.EmployeeCode);
      },
        (err: HttpErrorResponse) => {
          this.EmployeeCode = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  OnClearCode() {
    this.EmployeeCodeList.EmployeeCode = null;
    this.EmployeeCode = null;
    this.FTERecordsList.EmpGPN = null;
    this.FTERecordsList.EmpName = null;
  }

  SetSelectedCode(event: any) {
    this.FTERecordsList.EmpName = event.value.EmpName;
    this.FTERecordsList.EmpGPN = event.value.EmpGPN;
  }

  filterFilterCode(query: any, EmployeeCodeList: any[]): any[] {

    const filtered: any[] = [];
    if (EmployeeCodeList.length > 0) {
      for (let i = 0; i < EmployeeCodeList.length; i++) {
        const Emp = EmployeeCodeList[i];
        if (Emp.EmpGPN.toLowerCase().trim().indexOf(query.toLowerCase()) !== -1) {
          filtered.push(Emp);
        }
        else if (Emp.EmpCode.toLowerCase().trim().indexOf(query.toLowerCase()) !== -1) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.EmployeeCodeList.EmployeeCode = null;
      alert("Employee Record does not exist in the list!");

    }
    return filtered;
  }

  GetEmpNameSearch(event: any) {

    this.EmployeeName = [];
    const query = event.query;
    if ((query.length) >= 3) {

      this.gService.GetEmpNameSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {

        this.EmployeeName = [];
        this.EmployeeName = data;
        this.filteredEmployeeSingle = this.filterFilterEmp(query, this.EmployeeName);
      },
        (err: HttpErrorResponse) => {
          this.EmployeeName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }



  SetSelectedEmpGPN(event: any) {
    this.FTERecordsList.EmpName = event.value.EmpName;
    this.FTERecordsList.EmpGPN = event.value.EmpGPN;
  }

  OnClearSendUser() {
    this.EmployeeList.Employee = null;
    this.EmployeeName = null;
    this.FTERecordsList.EmpGPN = null;
    this.FTERecordsList.EmpName = null;
  }

  filterFilterEmp(query: any, EmployeeList: any[]): any[] {

    const filtered: any[] = [];
    if (EmployeeList.length > 0) {
      for (let i = 0; i < EmployeeList.length; i++) {
        const Emp = EmployeeList[i];
        if (Emp.EmpFullName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.EmployeeList.Employee = null;
      alert("Employee Record does not exist in the list!");
    }
    return filtered;
  }

  GetRepManagerSearch(event: any) {

    this.ManagerName = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetRepManagerSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {
        this.ManagerName = [];
        this.ManagerName = data;
        this.filteredManagerSingle = this.filterFilterManager(query, this.ManagerName);
      },
        (err: HttpErrorResponse) => {
          this.ManagerName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  SetSelectedRepManager(event: any) {

    this.FTERecordsList.EmpManagerName = event.value.EmpManagerName;
    this.FTERecordsList.EmpManagerGPN = event.value.EmpManagerGPN;
  }



  OnClearRepManager() {
    this.ManagerList.Manager = null;
    this.ManagerName = null;
    this.FTERecordsList.EmpManagerName = null;
    this.FTERecordsList.EmpManagerGPN = null;
  }


  filterFilterManager(query: any, ManagerList: any[]): any[] {

    const filtered: any[] = [];
    if (ManagerList.length > 0) {
      for (let i = 0; i < ManagerList.length; i++) {
        const Emp = ManagerList[i];
        if (Emp.EmpFullName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.FTERecordsList.EmpManagerName = null;
      alert("Employee Record does not exist in the list!");
    }

    return filtered;
  }

  GetSearchResult() {

    this.IsExport = false;
    this.gService.employeeDetailFromHrData(this.CurrUserGPN, this.ParamID, this.FTERecordsList, this.IsExport, this.IsAdmin).subscribe((data: any) => {
      if (data != null) {

        if (data.length > 0) {

          this.FTERecordsList.TopRecord = data[0]['TopRec'];
          this.FTERecordsList.TotalRecord = data[0]['TotRec'];
          this.FTERecordsList.RecordFrom = data[0]['RecordFrom'];
          this.FTERecordsList.RecordTo = parseFloat(data[0]['RecordFrom']) + (data.length - 1);
          this.FTERecordsList.TotalPageCount = data[0]['TotalPageCount'];
          this.ViewFTERecordsList = data;
        } else {
          this.ViewFTERecordsList = data;
          this.FTERecordsList.TopRecord = 0;
          this.FTERecordsList.TotalRecord = 0;
          this.FTERecordsList.RecordFrom = 0;
          this.FTERecordsList.RecordTo = 0;
          this.FTERecordsList.TotalPageCount = 0;
          this.FTERecordsList.currentPage = 1;
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }


  ResetResult() {
    this.FTERecordsList.EmpGPN = '';
    this.FTERecordsList.EmpLPN = '';
    this.FTERecordsList.EmpName = '';
    this.FTERecordsList.ServiceLineID = '';
    this.FTERecordsList.ServiceLineText = '';
    this.FTERecordsList.EmpTitle = '';
    this.FTERecordsList.EmpLocationID = '';
    this.FTERecordsList.EmpLocationText = '';
    this.FTERecordsList.EmpDOJ = '';
    this.FTERecordsList.EmpManagerGPN = '';
    this.FTERecordsList.EmpManagerName = '';
    this.FTERecordsList.EmpEmail = '';
    this.FTERecordsList.EmpEmail = '';
    this.FTERecordsList.EmpEmail = '';
    this.FTERecordsList.UpdatedEngagementCode = '';
    this.FTERecordsList.EngClientName = '';
    this.EmployeeList.Employee = '';
    this.ManagerList.Manager = '';
    this.EmployeeCodeList.EmployeeCode = '';
    this.EngagementList.EngCode = '';
    this.ClientList.Client = '';
    this.GetSearchResult();
  }

  sort(keyname: any) {
    this.sortkey = keyname;   // set the sortKey to the param passed
    this.reverse = !this.reverse; // if true make it false and vice versa
  }

  setPage(PageNumber: any) {
    this.FTERecordsList.currentPage = PageNumber;
    this.GetSearchResult();
  }
  PreviousPage() {
    this.FTERecordsList.currentPage = this.FTERecordsList.currentPage - 1;
    this.GetSearchResult();
  }
  NextPage() {

    this.FTERecordsList.currentPage = this.FTERecordsList.currentPage + 1;
    this.GetSearchResult();
  }
  firstPage() {
    this.FTERecordsList.currentPage = 1;
    this.GetSearchResult();
  }
  lastPage() {
    this.FTERecordsList.currentPage = this.FTERecordsList.TotalPageCount;
    this.GetSearchResult();
  }
  range(count: any) {
    const ratings = [];
    let TotalPage = count;
    const Start = this.FTERecordsList.currentPage - 1;
    if (count > 5) {
      TotalPage = this.FTERecordsList.currentPage + 4;
      if (TotalPage > this.FTERecordsList.TotalPageCount) {
        TotalPage = this.FTERecordsList.currentPage + (this.FTERecordsList.TotalPageCount - this.FTERecordsList.currentPage);
      }
    }
    for (let i = Start; i < TotalPage; i++) {
      ratings.push(i);
    }
    return ratings;
  }

  ExportToExcel() {

    this.FTERecordsList.IDList = '';
    this.IsExport = true;
    for (var i = 0; i < this.ViewFTERecordsList.length; i++) {
      if (this.ViewFTERecordsList[i].checked) {
        if (this.FTERecordsList.IDList == '') {
          this.FTERecordsList.IDList = this.ViewFTERecordsList[i].ID;
        }
        else {
          this.FTERecordsList.IDList += ',' + this.ViewFTERecordsList[i].ID
        }
      }
    }
    this.gService.employeeDetailFromHrData(this.CurrUserGPN, this.ParamID, this.FTERecordsList, this.IsExport, this.IsAdmin).subscribe((data: any) => {
      if (data != null) {

        if (data.length > 0) {
          this.ExcelUpload.exportAsExcelFile(data, 'FTE_List');
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  onExit() {
    this.boolReturn = false;
    this.boolReturn = confirm('Are you sure you want to Exit?');
    if (this.boolReturn === false) {
      return;
    }
    this.router.navigate(['/INFTE/home']);
  }

  GetEngCodeSearch(event: any) {

    this.EngagementCode = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetEngagementCodeSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {

        this.EngagementCode = [];
        this.EngagementCode = data;
        this.filteredEngagementSingle = this.filterFilterEngagementCode(query, this.EngagementCode);
      },
        (err: HttpErrorResponse) => {
          this.EngagementCode = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  OnClearEngagement() {
    this.EngagementList.EngCode = null;
    this.EngagementCode = null;
    this.FTERecordsList.UpdatedEngagementCode = null;
  }

  SetSelectedEngCode(event: any) {

    this.FTERecordsList.UpdatedEngagementCode = event.value.UpdatedEngagementCode;
  }

  filterFilterEngagementCode(query: any, EngagementList: any[]): any[] {

    const filtered: any[] = [];
    if (EngagementList.length > 0) {
      for (let i = 0; i < EngagementList.length; i++) {
        const Emp = EngagementList[i];
        if (Emp.UpdatedEngagementCode.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.EngagementList.EngCode = null;
      alert("Employee Record does not exist in the list!");
    }
    return filtered;
  }

  GetClientNameSearch(event: any) {

    this.ClientName = [];
    const query = event.query;
    if ((query.length) >= 3) {
      this.gService.GetClientNameSearch(query, this.gVariable.User.UserGPN).subscribe((data: any) => {

        this.ClientName = [];
        this.ClientName = data;
        this.filteredClientSingle = this.filterFilterClientName(query, this.ClientName);
      },
        (err: HttpErrorResponse) => {
          this.ClientName = [];
          this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(() => {
          });
          this.gService.RedirectToErrorPage(2);
        });
    }
  }

  OnClearClient() {
    this.ClientList.Client = null;
    this.ClientName = null;
    this.FTERecordsList.EngClientName = null;
  }

  SetSelectedClientGPN(event: any) {

    this.FTERecordsList.EngClientName = event.value.EngClientName;
  }

  filterFilterClientName(query: any, ClientList: any[]): any[] {

    const filtered: any[] = [];
    if (ClientList.length > 0) {
      for (let i = 0; i < ClientList.length; i++) {
        const Emp = ClientList[i];
        if (Emp.EngClientName.toLowerCase().trim().indexOf(query.toLowerCase()) === 0) {
          filtered.push(Emp);
        }
      }
    }
    else {
      this.ClientList.Client = null;
      alert("Employee Record does not exist in the list!");
    }
    return filtered;
  }

  onFTERecordClick(FTEID: any) {

    this.router.navigate(['/View/FTEForm/' + FTEID]);
  }

}

//END by Samikchha Kumar on 27-Mar-2023

